import ApiClient from "../helpers/ApiClient";
import useSWR from "swr";

const fetcher = (url) => ApiClient.get(url).then((res) => res.data);

export function useKitchenDisplays() {
  const APIURL = "/kitchen-displays";
  const { data, error, isLoading, mutate } = useSWR(APIURL, fetcher);
  const displays = Array.isArray(data) ? data : (Array.isArray(data?.data) ? data.data : []);
  return {
    data: displays,
    raw: data,
    error,
    isLoading,
    mutate,
    APIURL,
  };
}

export async function getKitchenDisplays() {
  try {
    const res = await ApiClient.get("/kitchen-displays");
    return res.data;
  } catch (error) {
    throw error;
  }
}

export async function createKitchenDisplay(payload) {
  try {
    const res = await ApiClient.post("/kitchen-displays", payload);
    return res.data;
  } catch (error) {
    throw error;
  }
}

export async function updateKitchenDisplay(id, payload) {
  try {
    const res = await ApiClient.put(`/kitchen-displays/${id}`, payload);
    return res.data;
  } catch (error) {
    throw error;
  }
}

export async function deleteKitchenDisplay(id) {
  try {
    const res = await ApiClient.delete(`/kitchen-displays/${id}`);
    return res.data;
  } catch (error) {
    throw error;
  }
}
